<template>
  <div class="hw-resource-preview">
    <van-nav-bar
        title="预览"
        left-arrow
        @click-left="$router.go(-1)"
    />
    <!-- 音视频 -->
    
    
    <div class="video-wraper" v-if="fileType < 3">
      <video :src="url" 
        controls
        :poster="coverURL"
        style="width:100%"
        v-if="isLocal"
       >
     </video>
      <videoplayer 
      ref="videoraasplayer"
      class="videoPlayerBox"
      v-else
    >
    </videoplayer>
    
    </div>
    <!-- 文档 -->
    <div 
      style="width:100%;height:100%;padding-top:18px"
      v-if="fileType === 3">

    </div>
    <!-- 图片 -->
    <div 
      style="width:100%" 
      v-if="fileType === 4">
      <img :src="url" style="width:100%"/>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  export default {
    name: 'hwResourcePreview',
    data() {
      return {

      }
    },
    created() {
      this.id = this.$route.params.id
      this.url = this.$route.params.url
      this.fileType = this.$route.params.fileType
      this.coverURL = this.$route.params.coverURL
      this.isLocal = this.$route.params.isLocal
    },
    mounted() {
      if(!this.isLocal) {
        this.showPreviewPlayer(this.curRow)

      }
    },
    methods: {
       showPreviewPlayer(row) {
        // if (row.transcodingStatus === 2) {
          var params = null
          if (this.fileType < 3) {
            this.$api.resource.previewMedias(this.id).then((res) => {
                if (res.success && res.data) {
                    params = {
                        format: 'm3u8',
                        mediaType: 'video',
                    }
                    // 视频，安全相关的
                    this.curVideoUrl = res.data
                    this.$nextTick(() => {
                        this.$refs.videoraasplayer.initPlayer(this.curVideoUrl, params)
                    })
                }
            })
          } else if (this.fileType === 4) {
            // 
          } else {
            this.$api.resource.getImageOrDocUrls(this.id).then((res) => {
              if (res.success) {
                this.pdfUrl = res.data
  
                // 下边是安全才有的
                // eslint-disable-next-line no-undef
                let demo = aliyun.config({
                  mount: document.querySelector('#Vidpreview'),
                  url: res.data.previewURL, //设置文档预览URL地址。
                })
                console.log('demo', demo)
                // //设置AccessToken。
                demo.setToken({ token: res.data.accessToken })
                // ppt存在动画才有，否则会报错
                if (row.name.split('.')[1] === 'ppt') {
                  demo.PPTApplication().ActivePresentation.SlideShowSettings.Run()
                  demo.PPTApplication().ActivePresentation.Slides.Count
                }
              } else {
                // this.$message.error(res.message);
              }
            })
          }
        // } else {
        //   this.$message.warning('转码成功方可预览')
        // }
      },
    },
       beforeDestroy() {
        // this.clearTimeing();
        // 离开当前路由删除 文档元素
        let Vidpreview=document.querySelector('.web-office-default-container')
        document.body.removeChild(Vidpreview)
    },
    destroyed() {
        window.removeEventListener("popstate", this.pdfTiming, false); //false阻止默认事件
    },
  }
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
>>>.van-nav-bar__content
  height 46px
.hw-resource-preview
  width 100%
  height 100%
  .video-wraper
    width 100%
    height calc(100vh - 92px)
</style>
